export default "__VITE_ASSET__CgevetaE__"